import { useState } from 'react';
import { Link, Outlet } from 'react-router';
import { useGuestSession } from '@/auth/react';
import { buttonClasses } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';
import { GuestSessionMissing } from '@/routes/guards';
import { CustomerShell } from '@/shells/CustomerShell';
import { CustomerProvider, useCustomer } from './context';
import { useCart } from './queries';

/** Shell for `/t/*`: needs a table session, loads the venue details, shows the cart count on the tab bar. */
export function CustomerLayout() {
  const session = useGuestSession();
  // Remembered only while this page stays open, to offer "Start again" when a session ends.
  const [lastQrToken, setLastQrToken] = useState(session?.qrToken ?? null);
  if (session && session.qrToken !== lastQrToken) setLastQrToken(session.qrToken);

  if (!session) {
    return (
      <CustomerShell showNav={false}>
        <GuestSessionMissing lastQrToken={lastQrToken} />
      </CustomerShell>
    );
  }
  return (
    <CustomerProvider
      key={session.sessionId}
      session={session}
      fallback={(content) => <CustomerShell showNav={false}>{content}</CustomerShell>}
    >
      <ShellWithCart />
    </CustomerProvider>
  );
}

/** An unknown address under `/t`: the guest stays in their visit and goes back to the menu. */
export function CustomerNotFound() {
  return (
    <EmptyState
      icon="pin"
      title="Page not found"
      message="That page doesn't exist, but your table is still open."
      action={
        <Link to="/t/menu" className={buttonClasses({ variant: 'primary' })}>
          Back to the menu
        </Link>
      }
    />
  );
}

function ShellWithCart() {
  const { table } = useCustomer();
  const cart = useCart();
  return (
    <CustomerShell title={table.restaurant_name} cartCount={cart.data?.total_quantity}>
      <Outlet />
    </CustomerShell>
  );
}
